import React, { useState } from 'react'
import clsx from 'clsx'
import { useFormContext, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  FormControl,
  TextInput,
  TextareaInput,
  Switch,
  Loader,
} from 'components'
import { statusFilter } from 'helpers/common'

function ProductCategoryForm(): JSX.Element {
  const { control, errors, watch, trigger, setValue } = useFormContext()

  const [codeChecking, setCodeChecking] = useState<boolean>(false)
  const [nameChecking, setNameChecking] = useState<boolean>(false)

  const values = watch(['code'])

  const { t } = useTranslation(['productCategory', 'common'])

  return (
    <div className='f-company__form'>
      <Controller
        as={TextInput}
        type='hidden'
        name='currentState'
        control={control}
      />
      <div className='f-company__form__status'>
        <Controller
          control={control}
          name='isActive'
          render={({ onChange, value }) => {
            return (
              <Switch
                checked={value}
                label={`${t('common:status.label')} ${statusFilter(value)}`}
                onChange={(e) => onChange(e.target.checked)}
              />
            )
          }}
        />
      </div>
      <section className={clsx('f-company__form__section')}>
        <label htmlFor='product category info'>
          {t('productCategory:productCategory.title')}
        </label>
        <div className='f-company__info'>
          {values.code && (
            <FormControl
              htmlFor='product category code'
              label={t('productCategory:productCategory.code.label')}
              required
            >
              <Controller
                type='text'
                name='code'
                control={control}
                render={(field) => (
                  <TextInput
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={async () => {
                      setCodeChecking(true)
                      await trigger('code')
                      setCodeChecking(false)
                    }}
                    placeholder={t(
                      'productCategory:productCategory.code.placeholder',
                    )}
                    isError={Boolean(errors.code?.message)}
                    message={errors.code?.message}
                    withIcon={codeChecking && <Loader />}
                    maxLength={30}
                    ref={field.ref}
                    disabled
                  />
                )}
              />
            </FormControl>
          )}
          <FormControl
            htmlFor='product category name'
            label={t('productCategory:productCategory.name.label')}
            required
          >
            <Controller
              type='text'
              name='name'
              control={control}
              render={(field) => (
                <TextInput
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={async () => {
                    setNameChecking(true)
                    setValue('currentState', 'name')
                    await trigger('name')
                    setValue('currentState', '')
                    setNameChecking(false)
                  }}
                  placeholder={t(
                    'productCategory:productCategory.name.placeholder',
                  )}
                  isError={Boolean(errors.name?.message)}
                  message={errors.name?.message}
                  withIcon={nameChecking && <Loader />}
                  maxLength={30}
                  ref={field.ref}
                />
              )}
            />
          </FormControl>

          <FormControl
            htmlFor='product category detail'
            label={t('productCategory:productCategory.detail.label')}
          >
            <Controller
              as={TextareaInput}
              name='detail'
              control={control}
              hasCountable
              maxLength={80}
              placeholder={t(
                'productCategory:productCategory.detail.placeholder',
              )}
              isError={Boolean(errors.detail?.message)}
              message={errors.detail?.message}
            />
          </FormControl>
        </div>
      </section>
    </div>
  )
}

export default ProductCategoryForm
